import handleErrorCallback from "../../utils/handleErrorCallback";
import { getUserRefreshToken } from "../auth";

const axios = require("axios");
const axiosApiInstance = axios.create();

axiosApiInstance.interceptors.request.use(
  async (config) => {
    const access_token = window.localStorage.getItem("token");
    config.headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      let res = null;
      try {
        res = await getUserRefreshToken();
      } catch (e) {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("refresh");
        window.location.href = "/sign";
      }
      window.localStorage.setItem("token", res.data?.data?.access);
      window.localStorage.setItem("refresh", res.data?.data?.refresh);
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + res.data?.data?.access;
      return axiosApiInstance(originalRequest);
    } else if (
      error.response.status != 200 &&
      error.response.status != 201 &&
      originalRequest._retry
    ) {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("refresh");
      window.location.href = process.env.REACT_APP_BASE_WEB_URL + "/sign";
    }
    if (
      error.response.status !== 200 &&
      error.response.status !== 201 &&
      error.response.status !== 401
    ) {
      handleErrorCallback(error);
    }
    return Promise.reject(error);
  }
);

export default axiosApiInstance;
